import React from 'react'

const ReceiveSlipPage = React.lazy(() => import('pages/ReceiveSlip/ReceiveSlipPage'));
const ReceiveSlipAddPage = React.lazy(() => import('pages/ReceiveSlip/ReceiveSlipAddPage'));

const ReceiveSlipRoutes = [
    {
        path: '/receive-slip',
        exact: true,
        name: 'Danh sách phiếu thu',
        function: 'RECEIVESLIP_VIEW',
        component: ReceiveSlipPage,
    },
    {
        path: '/receive-slip/add',
        exact: true,
        name: 'Thêm mới phiếu thu',
        function: 'RECEIVESLIP_ADD',
        component: ReceiveSlipAddPage,
    },
    {
        path: '/receive-slip/edit/:receive_slip_id',
        exact: true,
        name: 'Chỉnh sửa phiếu thu',
        function: 'RECEIVESLIP_EDIT',
        component: ReceiveSlipAddPage,
    },
    {
        path: '/receive-slip/detail/:receive_slip_id',
        exact: true,
        name: 'Chi tiết phiếu thu',
        function: 'RECEIVESLIP_VIEW',
        component: ReceiveSlipAddPage,
    },
]

export default ReceiveSlipRoutes
